export function isValidCIDR(cidr: string): boolean {
	try {
		const [ip, prefix] = cidr.split('/');
		if (!ip || !prefix) return false;

		const prefixNum = parseInt(prefix, 10);
		if (isNaN(prefixNum) || prefixNum < 0 || prefixNum > 32) return false;

		const parts = ip.split('.').map(Number);
		if (parts.length !== 4) return false;

		for (const part of parts) {
			if (isNaN(part) || part < 0 || part > 255) return false;
		}

		return true;
	} catch {
		return false;
	}
}

export function validateCIDRList(cidrList: string): string | null {
	if (!cidrList.trim()) return null; // Empty is valid

	const cidrs = cidrList
		.split(',')
		.map((c) => c.trim())
		.filter((c) => c);

	for (const cidr of cidrs) {
		if (!isValidCIDR(cidr)) {
			return `Invalid CIDR format: ${cidr}. Expected format: 192.168.1.0/24`;
		}
	}

	return null;
}

export function processCidrInput(input: string): string | undefined {
	return input.trim().replaceAll('\n', ',').replaceAll(' ', '') || undefined;
}
